export default __webpack_public_path__ + "static/media/2106_03 drawing.3e016f8d.gif";